type TGroupedObjectByDate<T> = Record<string, T[]>;

function getDateKey(dateInput: Date | string | null | undefined): string {
  if (!dateInput) return "unknown";

  const date = new Date(dateInput);
  if (Number.isNaN(date.getTime())) return "unknown";

  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(
    date.getDate()
  ).padStart(2, "0")}`;
}

export function groupByCreatedDate<T extends { created_at: Date | string }>(
  files: T[]
): TGroupedObjectByDate<T> {
  const grouped = files.reduce<TGroupedObjectByDate<T>>((acc, file) => {
    const key = getDateKey(file.created_at);

    if (!acc[key]) {
      acc[key] = [];
    }

    acc[key].push(file);
    return acc;
  }, {});

  return Object.fromEntries(Object.entries(grouped).sort(([a], [b]) => b.localeCompare(a)));
}

export function getSortedDateKeys<T>(grouped: Record<string, T[]>): string[] {
  return Object.keys(grouped).sort((a, b) => b.localeCompare(a));
}

export function getLatestByCreatedDate<T extends { created_at?: Date | string }>(files: T[]): T[] {
  const withDates = files.filter(
    (file): file is T & { created_at: Date | string } => !!file.created_at
  );
  if (!withDates.length) return [];

  const grouped = groupByCreatedDate(withDates);
  const latestDate = getSortedDateKeys(grouped)[0];
  return latestDate ? (grouped[latestDate] ?? []) : [];
}
